<template>
  <ul class="space-y-4 pr-96">
    <!-- html likethis cause don't know api structure -->
    <li>
      <h2 class="text-black-900 font-medium text-base mb-2">Mailing Address</h2>

      <div class="text-black-600 text-base">
        Epigram Books <br />
        1008 Toa Payoh North <br />
        #03-08<br />
        Singapore 318996<br />
        Our showroom is a 5-minute walk from Braddell (NS18) MRT Station.
      </div>
    </li>
    <li>
      <h2 class="text-black-900 font-medium text-base mb-2">Telephone</h2>

      <div class="text-black-600 text-base hover:text-orange-900">
        <a href="tel:(+65) 6292 4456">(+65) 6292 4456</a>
      </div>
    </li>
    <li>
      <h2 class="text-black-900 font-medium text-base mb-2">E-mail</h2>

      <div class="text-black-900 text-base">
        <a
          class="underline hover:text-orange-900"
          href="mailto:rights@epigram.sg"
          >rights@epigram.sg
        </a>
      </div>
    </li>
    <li>
      <h2 class="text-black-900 font-medium text-base mb-2">
        Getting Published
      </h2>

      <div class="text-black-600 text-base">
        Find more information about getting your manuscript published here.
      </div>
    </li>
    <li>
      <h2 class="text-black-900 font-medium text-base mb-2">Distribution</h2>

      <div class="text-black-600 text-base">
        If you would like to retail our books in the ASEAN region, please reach
        out to our appointed distributor APD Singapore at
        <a
          class="text-black-900 underline hover:text-orange-900"
          href="mailto:rights@epigram.sg"
          >rights@epigram.sg.
        </a>
        If you would like to retail our books beyond the ASEAN region, please
        contact us at
        <a
          class="text-black-900 underline hover:text-orange-900"
          href="mailto:rights@epigram.sg"
          >sales@epigram.sg.
        </a>
      </div>
    </li>
    <li>
      <h2 class="text-black-900 font-medium text-base mb-2">
        Rights &amp; Permissions
      </h2>

      <div class="text-black-600 text-base">
        If you're seeking permission to translate or reproduce any of our
        content, please contact us at
        <a
          class="text-black-900 underline hover:text-orange-900"
          href="mailto:rights@epigram.sg"
          >rights@epigram.sg.
        </a>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "TabInformation",
};
</script>
